export default __webpack_public_path__ + "static/media/chainIcon.7556693a.svg";